import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

interface Props {
  data: { name: string; value: number }[];
}

const ChartCard: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-4">
    <p className="text-[10px] font-bold uppercase tracking-widest text-slate-500 mb-3">{title}</p>
    {children}
  </div>
);

export const TopSubscriptionsChart: React.FC<Props> = ({ data }) => {
  if (data.length === 0) return null;

  // Truncate long names
  const display = data.map(d => ({
    ...d,
    shortName: d.name.length > 18 ? d.name.slice(0, 16) + '…' : d.name,
  }));

  return (
    <ChartCard title="Top Subscriptions (Monthly Cost)">
      <ResponsiveContainer width="100%" height={240}>
        <BarChart data={display} layout="vertical" margin={{ top: 4, right: 8, left: 8, bottom: 4 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#F1F5F9" horizontal={false} />
          <XAxis
            type="number"
            tickFormatter={(v: number) => v >= 1000 ? `$${(v / 1000).toFixed(0)}K` : `$${v}`}
            tick={{ fontSize: 10, fill: '#94A3B8' }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            type="category"
            dataKey="shortName"
            tick={{ fontSize: 10, fill: '#64748B' }}
            axisLine={false}
            tickLine={false}
            width={110}
          />
          <Tooltip
            formatter={(v: number) => `$${v.toLocaleString()}/mo`}
            labelFormatter={(_, payload) => payload?.[0]?.payload?.name || ''}
            contentStyle={{ fontSize: 12, borderRadius: 8, border: '1px solid #E2E8F0' }}
          />
          <Bar dataKey="value" fill="#0891B2" radius={[0, 4, 4, 0]} barSize={16} />
        </BarChart>
      </ResponsiveContainer>
    </ChartCard>
  );
};
